/**
 * Runs tasks one at a time, in the order they were handed over.
 *
 * <p>For screens where every save answers with the whole document: run two at once and the
 * older answer can land last and overwrite the newer one (field test B-42, the template
 * total that read 53 while the server held 100.5).</p>
 */
export function serial() {
  let tail: Promise<unknown> = Promise.resolve();

  return function run<T>(task: () => Promise<T>): Promise<T> {
    const next = tail.then(task, task);
    tail = next.catch(() => undefined);
    return next;
  };
}
